import { Box, styled } from "@mui/material";
import { INote } from "models/notes";
import NoteMarkdown from "./NoteMarkdown";
import NoteHeading from "./NoteHeading";
import DeletedNoteContent from "./DeletedNoteContent";

const QuoteContainer = styled(Box)(({theme}) => ({
    boxShadow: `0px 0px 2px 0px #0000004D`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '4px',
    fontSize: '15px'
}));

type NoteQuoteCardProps = {
    note: INote;
};

const NoteQuoteCard: React.FC<NoteQuoteCardProps> = (props) => {
    return (
        <QuoteContainer>
            <NoteHeading note={props.note} />
            { props.note.isDeleted 
            ? <div style={{ padding: '8px'}}><DeletedNoteContent /></div>
            : <NoteMarkdown note={props.note.note} isChild/>
            }
        </QuoteContainer>
    );
};

export default NoteQuoteCard;
